import { EApplicantOfferPGKeys, EApplicationPGKeys } from '../apply';
import { EStudentImportAttributeFieldNames } from './attributes';

/**
 * Object that maps conversions between import attribute EStudentImportAttributeFieldNames names and postgres columns.
 * Allows office configurations to be directly converted to postgres conditional statements.
 * Setup for the applicant offers table. 
 */
export const ApplicantOfferOfficesConditionMap = Object.freeze({
  [EStudentImportAttributeFieldNames.COUNTRY_OF_BIRTH]: EApplicantOfferPGKeys.BIRTH_COUNTRY,
  [EStudentImportAttributeFieldNames.NATIONALITY]: EApplicantOfferPGKeys.NATIONALITY,
  [EStudentImportAttributeFieldNames.COUNTRY]: EApplicantOfferPGKeys.APPLICATION_COUNTRY,
  [EStudentImportAttributeFieldNames.INTAKE_ID]: EApplicantOfferPGKeys.INTAKE_ID,
  [EStudentImportAttributeFieldNames.UNI]: EApplicantOfferPGKeys.UNI,
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_ID]: EApplicantOfferPGKeys.COURSE_ID,
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_TITLE]: EApplicantOfferPGKeys.COURSE_NAME
});
 
/**
 * Object that maps conversions between import attribute EStudentImportAttributeFieldNames names and postgres columns.
 * Allows office configurations to be directly converted to postgres conditional statements.
 * Setup for the applications table.
 */
export const ApplicationOfficesConditionMap = Object.freeze({
  [EStudentImportAttributeFieldNames.COUNTRY]: EApplicationPGKeys.APPLICATION_COUNTRY,
  [EStudentImportAttributeFieldNames.NATIONALITY]: EApplicationPGKeys.NATIONALITY,
  [EStudentImportAttributeFieldNames.INTAKE_ID]: EApplicationPGKeys.INTAKE_ID,
  [EStudentImportAttributeFieldNames.UNI]: EApplicationPGKeys.UNI,
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_ID]: EApplicationPGKeys.COURSE_ID,
  [EStudentImportAttributeFieldNames.OFFERS_COURSES_TITLE]: EApplicationPGKeys.COURSE_NAME
});
